<ng-container>
  <div class="sidebar-container">
    <div id="side-bar" class="side-bar-sidenav" 
      (mouseenter)="onSidebarHoverEnter($event)"
      (mouseleave)="onSidebarHoverLeave($event)">
      <nav>
        <ul class="side-bar-menu-container">
          <!-- Menu Item Template -->
          <li
            class="menu-item-li"
            (click)="openSideBar($event)"
            [ngClass]="{ 'menu-item-active': isItemActive(menuItem.path) }"
            *ngFor="let menuItem of menuItems; trackBy: trackByMenuTabKey"
          >
            <div
              class="menu-item-container"
              *ngIf="!menuItem.redirection_url"
              [routerLink]="!menuItem.submenu ? getAbsolutePath(menuItem.path) : null"
              [queryParams]="getQueryParams(menuItem.firstTab)"
              [ngClass]="{
                'menu-item-main-menu': true,
                'menu-item-active-link': menuItem.path === activePath && isSidebarHovered && !isAnySubmenuActive(menuItem),
                'menu-item-active-link-text': isAnySubmenuActive(menuItem)
              }"
              (click)="menuItem.submenu ? toggleSubMenuForItem(menuItem) : onItemClick(menuItem.path)"
              tabindex="0"
              [attr.aria-expanded]="menuItem.submenu ? menuItem.showSubMenu : null"
              [attr.aria-haspopup]="menuItem.submenu ? 'true' : null"
            >
              <!-- Menu Icon -->
              <span
                class="menu-icon-wrapper"
                [ngClass]="{ 'menu-icon-active-bg': (menuItem.path === activePath || isAnySubmenuActive(menuItem)) && !isSidebarHovered }"
              >
                <svg class="menu-icon-img">
                  <use [attr.xlink:href]="menuItem.icon"></use>
                  <!-- <use [attr.xlink:href]="(menuItem.path === activePath || isAnySubmenuActive(menuItem)) ? menuItem.activeIcon : menuItem.icon"></use> -->
                </svg>
              </span>

              <!-- Menu Title -->
              <span class="menu-item-title" *ngIf="itemsVisible && isSidebarHovered">{{ menuItem.title }}</span>

              <!-- Submenu Caret Icon: shows only if submenu exists -->
              <span *ngIf="menuItem.submenu && isSidebarHovered" class="menu-item-caret">
                <img
                  class="menu-item-submenu-option-icon"
                  [src]="menuItem.showSubMenu ? 'assets/images/up-arrow.svg' : 'assets/images/down-arrow.svg'"
                  alt="submenu-caret"
                />
              </span>

              <!-- Right Buttons -->
              <div
                *ngIf="itemsVisible && isSidebarHovered && menuItem.labelRight"
                [ngClass]="{
                   'menu-item-outbox-right-button': menuItem.title === 'Outbox',
                   'menu-item-right-button': menuItem.title !== 'Outbox',
                   'menu-item-right-button-active': menuItem.title !== 'Outbox' && menuItem.path === activePath }"
              >
                <span
                [ngClass]="{
                  'menu-item-outbox-right-button-lable': menuItem.title === 'Outbox',
                  'menu-item-right-button-label': menuItem.title !== 'Outbox',
                  'menu-item-right-label-active': menuItem.title !== 'Outbox' && menuItem.path === activePath
                }"
                >
                  {{ menuItem.labelRight }}
                </span>
              </div>
            </div>
            <div
              class="menu-item-container"
              *ngIf="menuItem.redirection_url && menuItem.redirection_url != '' && menuItem.redirection_url != null"
              [ngClass]="{'menu-item-main-menu': true}"
              (click)="onRedirectClick(menuItem); $event.stopPropagation()"
              tabindex="0">
              <!-- Menu Icon -->
              <span
                class="menu-icon-wrapper"
                [ngClass]="{ 'menu-icon-active-bg': (menuItem.path === activePath || isAnySubmenuActive(menuItem)) && !isSidebarHovered }"
              >
                <svg class="menu-icon-img">
                  <use [attr.xlink:href]="menuItem.icon"></use>
                </svg>
              </span>
              <!-- <span class="menu-icon-wrapper">
                <img
                class="menu-icon-img"
                  [src]="'assets/images/quicksight.svg'"
                  alt="redirect-icon"
                />
              </span> -->

              <!-- Menu Title -->
              <span class="menu-item-title" *ngIf="itemsVisible && isSidebarHovered">{{ menuItem.title }}</span>

              <!-- Submenu Caret Icon: shows only if submenu exists -->
              <span class="menu-item-caret" *ngIf="itemsVisible && isSidebarHovered">
                <img
                  class="menu-item-submenu-option-icon menu-item-launch-icon"
                  [src]="'assets/images/launch.svg'"
                  alt="redirect-icon"
                />
              </span>
            </div>
            <!-- Submenu Items: Rendered directly below parent, indented, only if open -->
            <ul
              *ngIf="menuItem.submenu && menuItem.showSubMenu && isSidebarExpanded"
              class="menu-item-sub-menu"
              [ngClass]="{ 'menu-item-expanded': menuItem.showSubMenu }"
            >
              <li
                class="menu-item-li"
                (click)="openSideBar($event)"
                [ngClass]="{ 'menu-item-active': isItemActive(subItem.path) }"
                *ngFor="let subItem of menuItem.submenu; trackBy: trackByMenuTabKey"
              >
                <div
                  class="menu-item-container"
                  [routerLink]="!subItem.submenu ? getAbsolutePath(subItem.path) : null"
                  [queryParams]="getQueryParams()"
                  [ngClass]="{
                    'menu-item-active-link': subItem.path === activePath && isSidebarHovered
                  }"
                  (click)="subItem.submenu ? toggleSubMenuForItem(subItem) : onItemClick(subItem.path); $event.stopPropagation()"
                  tabindex="0"
                  [attr.aria-expanded]="subItem.submenu ? subItem.showSubMenu : null"
                  [attr.aria-haspopup]="subItem.submenu ? 'true' : null"
                >
                  <!-- Submenu Icon -->
                  <span
                    class="menu-icon-wrapper"
                    [ngClass]="{ 'menu-icon-active-bg': subItem.path === activePath && !isSidebarHovered }"
                  >
                    <svg class="menu-icon-img">
                      <use [attr.xlink:href]="subItem.path === activePath ? subItem.activeIcon : subItem.icon"></use>
                    </svg>
                  </span>

                  <!-- Submenu Title -->
                  <span class="menu-item-title" *ngIf="itemsVisible && isSidebarHovered">{{ subItem.title }}</span>

                  <!-- Submenu Caret Icon: shows only if submenu exists -->
                  <span *ngIf="subItem.submenu" class="menu-item-caret">
                    <img
                      class="menu-item-submenu-option-icon"
                      [src]="subItem.showSubMenu ? 'assets/images/up-arrow.svg' : 'assets/images/down-arrow.svg'"
                      alt="submenu-caret"
                    />
                  </span>

                  <!-- Right Buttons -->
                  <div
                    *ngIf="itemsVisible && isSidebarHovered && subItem.labelRight"
                    [ngClass]="{
                       'menu-item-outbox-right-button': subItem.title === 'Outbox',
                       'menu-item-right-button': subItem.title !== 'Outbox',
                       'menu-item-right-button-active': subItem.title !== 'Outbox' && subItem.path === activePath }"
                  >
                    <span
                    [ngClass]="{
                      'menu-item-outbox-right-button-lable': subItem.title === 'Outbox',
                      'menu-item-right-button-label': subItem.title !== 'Outbox',
                      'menu-item-right-label-active': subItem.title !== 'Outbox' && subItem.path === activePath
                    }"
                    >
                      {{ subItem.labelRight }}
                    </span>
                  </div>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</ng-container>
